import axios from "axios";
import { useState } from "react";

export default function AddUser(props){
    
   const [price, setPrice] = useState(0);

    function priceHandler(e) {
        switch (e.target.value) {
            case "Trial":
            setPrice(0);
            break;
            case "3 Month Plan":
            setPrice(299);
            break;
            case "6 Month Plan":
            setPrice(499);
            break;
            case "1 Year Plan":
            setPrice(899);
            break;
            default:
            setPrice(0);
        }
    }
    function submitHandler(e){ 
        e.preventDefault();
        const obj = new FormData(e.target);
        const data = Object.fromEntries(obj.entries()); 
        axios.post(`${process.env.REACT_APP_BASE_URL}api/plan/secured/createPlan`,data)
        .then(result=>{alert("Create Successfully!");window.location.href="/plan"})
        .catch(err=>alert(err.response.data));
    }

    return(<div className="small-form-container container">
            <button className="btn btn-danger" style={{float:"right"}} onClick={()=>props.event(false)}>X</button>
        <div className="text-center">
            <h2>Create Plan</h2>
        </div><hr />
        <div className="form">
            <form onSubmit={submitHandler}>
                <div className="row">
                        <div>
                            <select className="form-select" name="planType" onChange={priceHandler} required>
                                <option value="Trial">Trial Plan</option>
                                <option value="3 Month Plan">3 Month Plan</option>
                                <option value="6 Month Plan">6 Month Plan</option>
                                <option value="1 Year Plan">1 Year Plan</option>
                            </select> 
                        </div>
                        <div>
                            <input className="form-control" type="text" name="price" placeholder="Price" Value={price} required />
                        </div>
                        <div>
                            <button className="btn btn-color form-control">Submit</button>
                        </div> 
                </div> 
            </form>
        </div>
    </div>);
}